var $brandingVariant = $("[data-branding-visual]");
var activeClass = "is-active";
var visibleClass = "is-visible";
var brandingColorClass = ".js-branding-color__color";
var brandingDescClass = ".js-branding-color__description";
ZDT.brandingVariant = false;

$brandingVariant
  .on("click", function() {
    var $this = $(this);
    var $brandingBall = $this.find(brandingColorClass);
    var $brandingDesc = $this.find(brandingDescClass);
    var $loopBrandingDesc = $this.find(
      ".js-branding-color__description--in-loop"
    );

    if ($loopBrandingDesc.length) {
      var rightPositionMath =
        $(window).outerWidth() -
        ($loopBrandingDesc.offset().left + $loopBrandingDesc.outerWidth());

      if (rightPositionMath < 20) {
        var rightMarginCurrent = parseInt($brandingDesc.css("margin-left"));
        var rightMarginMath = -20 + rightPositionMath + rightMarginCurrent;

        $brandingDesc.css("margin-left", rightMarginMath);
      }
    }

    $brandingBall.addClass(activeClass);
    $brandingDesc.addClass(visibleClass);

    ZDT.brandingVariant = true;
  })
  .on("mouseleave", function() {
    var $this = $(this);

    ZDT.timeOut = setTimeout(function() {
      var $brandingBall = $this.find(brandingColorClass);
      var $brandingDesc = $this.find(brandingDescClass);

      $brandingBall.removeClass(activeClass);
      $brandingDesc.removeClass(visibleClass);

      ZDT.brandingVariant = false;
    }, 1000);
  })
  .on("mouseenter", function() {
    if (ZDT.brandingVariant) {
      clearTimeout(ZDT.timeOut);
    }
  });
